import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface StorageLabelDesignState {
  printsNewDesign: boolean;
  setPrintsNewDesign: (printsNewDesign: boolean) => void;
}

/** Whether this computer prints the new wheel set label; the others keep the previous one until they opt in. */
export const useStorageLabelDesignStore = create<StorageLabelDesignState>()(
  persist(
    (set) => ({
      printsNewDesign: false,
      setPrintsNewDesign: (printsNewDesign) => set({ printsNewDesign })
    }),
    { name: 'storage-label-new-design' }
  )
);
